/**
 * 収運処分業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'
import {DRIVER_TRADER_RESET_CONDITION} from "../../../mutation-types/driver-types";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/traders`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      name: null,
      subscriber_number: null,
    },
  }
}

 const trader = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 収運処分業者一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param name
     * @param subscriber_number
     * @param page
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { name, subscriber_number, page }) {
      dispatch('saveCondition', { name: name, subscriber_number: subscriber_number })
      const params = { name: state.condition.name, subscriber_number: state.condition.subscriber_number, page: page }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.DRIVER_TRADER, { content })
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { name, subscriber_number }) {
      const _name = (name !== undefined) ? name : state.condition.name
      const _subscriber_number = (subscriber_number !== undefined) ? subscriber_number : state.condition.subscriber_number
      const params = { name: _name, subscriber_number: _subscriber_number }
      commit(types.DRIVER_TRADER_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_TRADER_RESET_CONDITION)
    },
  },
  mutations: {
    [types.DRIVER_TRADER_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_DISPOSER] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_TRADER_CONDITION] (state, { params }) {
      state.condition.name = params.name
      state.condition.subscriber_number = params.subscriber_number
    }
  },

 }

 export default trader
